import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

export const instructionLength = (text = '') => {
  if (typeof Intl.Segmenter === 'function') return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text)).length;
  return Array.from(text).length;
};
export const validateInstruction = (text = '') => {
  if (text && !text.trim()) return 'Enter instructions or clear the field completely.';
  return instructionLength(text) <= 500 || 'Use 500 characters or fewer.';
};
export default function InstructionInput({ control, name = 'text', label, onChange, disabled }) {
  return <Controller name={name} control={control} rules={{ validate: validateInstruction }} render={({ field, fieldState: { error } }) => (
    <TextField {...field} value={field.value || ''} onChange={(event) => { field.onChange(event); onChange?.(event.target.value); }}
      label={label} multiline minRows={3} fullWidth disabled={disabled} error={Boolean(error)}
      helperText={error?.message || `${instructionLength(field.value || '')}/500 · Phone numbers are masked when saved. Do not include contact, payment, or confidential details.`} />
  )} />;
}
